var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"color":"#FFFFFF","width":"95vw","height":"auto","font-size":"11px"}},[_c('iframe',{staticClass:"iframe",staticStyle:{"height":"40px","font-size":"11px","margin-top":"4px"},attrs:{"src":'/title.html?title=' + _vm.introduce,"frameborder":"0","width":"100%"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }